import { Box, Button, Dialog, Flex, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { ErrorOutlineIcon } from 'shared/icons';

const PlanActionConfirmDialogView = ({
   onConfirm,
   title,
   message,
   loading = false,
}: {
   title: string;
   message: string;
   onConfirm: () => void;
   loading?: boolean;
}) => {
   return (
      <Box className="deactivated-dialog">
         <Flex justify="center">
            <Text color="red">
               <ErrorOutlineIcon width={80} height={80} />
            </Text>
         </Flex>

         <Flex justify="center" direction="column" align="center" mt="5" mb="6">
            <Dialog.Title aria-describedby={undefined}>
               <Text>{title}</Text>
            </Dialog.Title>
            <Text> {message}</Text>
         </Flex>

         <Flex justify="center" gap="3">
            <Button color="red" size="3" loading={loading} onClick={onConfirm}>
               Confirm
            </Button>

            <Dialog.Close>
               <Button color="gray" size="3">
                  Cancel
               </Button>
            </Dialog.Close>
         </Flex>
      </Box>
   );
};

export const PlanActionConfirmDialog = observer(PlanActionConfirmDialogView);
